module.exports = __webpack_public_path__ + "06_bob_gold.da3365d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_bob_gold.png
// module id = X29M
// module chunks = 0